import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import { generateUuid } from '@lib/uuid';
import { useToast } from '@nx-frontend/shared/ui/toast';
import { calcNewBlockIndex } from '@nx-frontend/shared/blocks/utlis';
import { useBlockCreate } from '@nx-frontend/shared/hooks';
import { scrollToBlockEvent } from '@nx-frontend/shared/store/customizer-controlbar-store';
import { $blocksByPlace } from '@nx-frontend/shared/store/portal-blocks';
import { PortalPersistentBlock } from '@nx-frontend/shared/types';
import { generateUniqueTitle } from './generateUniqueTitle';

interface BlockDuplicateProps {
  block: PortalPersistentBlock;
  batchId?: string;
  collectId?: string;
  toastTitle?: string;
}

export const useBlockDuplicate = () => {
  const t = useTranslations('customizer');
  const [blocksByPlace, scrollToBlock] = useUnit([$blocksByPlace, scrollToBlockEvent]);
  const createBlock = useBlockCreate();
  const { toast } = useToast();

  return async ({
    block: sourceBlock,
    batchId,
    collectId,
    toastTitle = t('customizer-duplicate_block_toast'),
  }: BlockDuplicateProps) => {
    const blocks = blocksByPlace[sourceBlock.place];
    const blockId = generateUuid();

    const newBlock: PortalPersistentBlock = {
      ...sourceBlock,
      id: blockId,
      index: calcNewBlockIndex({ blocks }),
      title: generateUniqueTitle(
        sourceBlock.title,
        blocks.map((block) => block.title)
      ),
    };

    const { block } = await createBlock({ block: newBlock, openPageAfterCreate: false, batchId, collectId });
    scrollToBlock(block);
    toast({ title: toastTitle });

    return { blockId, collectId };
  };
};
